<template>
  <div>
    <nav
      class="navbar navbar-expand-md navbar-white navbar-light p-2 fixed-top"
      style="background: linear-gradient(to RIGHT, #0f4c96, #092f56)"
    >
      <a @click.prevent="inicio">
        <a class="navbar-brand" style="display: flex; align-items: center">
          <img
            src="@/assets/logobaessh.svg"
            alt="AdminLTE Logo"
            class="brand-image img-circle"
            style="margin-right: 0.5rem; width: 33px; height: 33px; object-fit: contain;"
          />
          <span class="brand-text font-weight-light" style="color: white"
            >BAESSH</span
          >
        </a>
      </a>
      <button
        ref="navbarToggler"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="true"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div ref="navbarCollapse" class="navbar-collapse collapse" id="navbarsExampleDefault" style="">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a
              href="#"
              :class="['nav-link', 'header-nav-link', { 'header-nav-link--active': isInicioActive }]"
              @click.prevent="inicio"
            >
              <i class="fas fa-house mr-2"></i>Inicio
            </a>
          </li>
          <li class="nav-item" v-if="Number(role) === 1">
            <router-link
              to="/ayuda"
              :class="['nav-link', 'header-nav-link', { 'header-nav-link--active': isAyudaActive }]"
              @click.native="closeMobileNav"
              ><i class="fas fa-circle-question mr-2"></i>Ayuda</router-link
            >
          </li>
          <li class="nav-item" v-if="Number(role) === 2">
            <router-link
              to="/home-cap/resultados"
              :class="['nav-link', 'header-nav-link', { 'header-nav-link--active': isResultadosActive }]"
              @click.native="closeMobileNav"
            >
              <i class="fas fa-ranking-star mr-2"></i>Resultados
            </router-link>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li v-if="Number(role) === 2" class="nav-item ranking-nav-item">
            <router-link
              to="/home-cap/resultados"
              class="ranking-badge"
              :title="rankingTitle"
              @click.native="closeMobileNav"
            >
              <i class="fas fa-trophy mr-1"></i>{{ rankingLabel }}
            </router-link>
          </li>
          <li ref="userMenuWrap" :class="['nav-item', 'dropdown', { show: userMenuOpen }]">
            <a
              id="dropdownSubMenu1"
              href="#"
              @click.prevent.stop="toggleUserMenu"
              aria-haspopup="true"
              :aria-expanded="String(userMenuOpen)"
              class="nav-link dropdown-toggle"
              style="white-space: normal; color: white"
              >{{ user }}<i class="fas fa-user ml-3"></i></a
            >
            <ul
              aria-labelledby="dropdownSubMenu1"
              :class="['dropdown-menu', 'border-0', 'shadow', { show: userMenuOpen }]"
              style="right: 0; left: auto"
            >
              <li v-if="role == 1">
                <router-link
                  to="/changepassword"
                  class="nav-link dropdown-item"
                  @click.native="closeUserMenu"
                  style="color: black"
                  >Cambiar contraseña</router-link
                >
              </li>
              <li>
                <a class="d-block dropdown-item" @click="closeUserMenu(); cerrarSesion()"
                  >Cerrar Sesión</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import axiosInstance, { getAccessToken, setAccessToken } from "@/services/axiosInstance";
import $ from "jquery";

export default {
  props: ["mensaje"],
  name: "HeaderPage",
  components: {},
  data() {
    return {
      user: "",
      role: null,
      userMenuOpen: false,
      rankingResumen: null,
    };
  },
  computed: {
    isAyudaActive() {
      return this.$route.path.startsWith("/ayuda");
    },
    isResultadosActive() {
      return this.$route.path.startsWith("/home-cap/resultados");
    },
    isInicioActive() {
      if (Number(this.role) === 1) return this.$route.path.startsWith("/home");
      return this.$route.path === "/home-cap" || this.$route.path.startsWith("/home-cap/calendario");
    },
    rankingLabel() {
      if (!this.rankingResumen || !this.rankingResumen.rankingActual) return "Sin ranking";
      return `#${this.rankingResumen.rankingActual} Ranking`;
    },
    rankingTitle() {
      if (!this.rankingResumen || !this.rankingResumen.rankingActual) {
        return "Aun no tienes ranking por encuestas";
      }
      return `Lugar ${this.rankingResumen.rankingActual} de ${this.rankingResumen.totalRanking}`;
    },
  },
  methods: {
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    closeUserMenu() {
      this.userMenuOpen = false;
    },
    closeMobileNav() {
      if (window.innerWidth >= 768) return;

      const collapse = this.$refs.navbarCollapse;
      const toggler = this.$refs.navbarToggler;
      if (!collapse?.classList.contains("show")) return;

      if ($?.fn?.collapse) {
        $(collapse).collapse("hide");
        return;
      }

      collapse.classList.remove("show");
      toggler?.classList.add("collapsed");
      toggler?.setAttribute("aria-expanded", "false");
    },
    handleOutsideClick(event) {
      const wrapper = this.$refs.userMenuWrap;
      if (!wrapper) return;
      if (!wrapper.contains(event.target)) this.userMenuOpen = false;
    },
    inicio() {
      this.closeMobileNav();
      if (this.role == 1) {
        this.$router.push("/home").catch(() => {
          window.location.reload(); // fuerza refresh si ya estás ahí
        });
      } else {
        this.$router.push("/home-cap").catch(() => {
          window.location.reload();
        });
      }
    },
    async cerrarSesion() {
      try {
        await axiosInstance.post("/users/auth/logout", {
          __skip401Handler: true,
        });
      } catch (_) {
        // si ya caducó, nos da igual
      } finally {
        setAccessToken(null);
        localStorage.removeItem("role");
        localStorage.removeItem("user");
        this.$router.push("/");
      }
    },
    async cargarRankingResumen() {
      if (Number(this.role) !== 2) return;

      try {
        if (!getAccessToken()) {
          const { data: authData } = await axiosInstance.get("/users/auth/refresh", {
            __skip401Handler: true,
          });
          setAccessToken(authData.accessToken);
        }

        const { data } = await axiosInstance.get("/cap/encuestas/ranking-resumen");
        this.rankingResumen = data;
      } catch (error) {
        this.rankingResumen = null;
      }
    },
  },
  created() {
    this.user = localStorage.getItem("user");
    this.role = localStorage.getItem("role");
    this.cargarRankingResumen();
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style>
.img-circle {
  max-width: 45px;
}

.header-nav-link {
  color: white !important;
  position: relative;
  transition: color 0.2s ease;
}

.header-nav-link::after {
  content: "";
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 3px;
  height: 2px;
  background: rgba(255, 255, 255, 0.95);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.25s ease;
}

.header-nav-link--active::after {
  transform: scaleX(1);
}

.ranking-nav-item {
  align-items: center;
  display: flex;
  padding: 4px 8px;
}

.ranking-badge {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  color: #ffffff;
  display: inline-flex;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  padding: 8px 10px;
  white-space: nowrap;
}

.ranking-badge:hover {
  color: #ffffff;
  text-decoration: none;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=UTF8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E") !important;
}

@media (max-width: 767.98px) {
  .ranking-nav-item {
    justify-content: center;
    padding-left: 8px;
    padding-right: 8px;
    width: 100%;
  }

  .ranking-badge {
    justify-content: center;
    margin: 4px auto 8px;
  }
}
</style>
